import IphoneMockup from 'components/IphoneMockup'
import DraggableScrollComponent from 'components/core/DraggableScrollComponent'
import { ShiftHeader } from './ShiftHeader'
import { LocationMap } from './LocationMap'
import { AboutSection } from './AboutSection'
import { RequirementSection } from './RequirementSection'
import { MobileChrome } from './MobileChrome'
import { PreviewContent } from './styles'
import { OnDemandDeliveryInfo } from './OnDemandDeliveryInfo'

export const Preview = () => {
  return (
    <IphoneMockup>
      <MobileChrome />
      <DraggableScrollComponent>
        <PreviewContent role="region" aria-label="Worker mobile preview">
          <ShiftHeader />
          <OnDemandDeliveryInfo />
          <LocationMap />
          <AboutSection />
          <RequirementSection />
        </PreviewContent>
      </DraggableScrollComponent>
    </IphoneMockup>
  )
}
